// 引入vue中定义的指令对应的类型定义
import store from '@/store'
import { getUser,getButtons } from '@/utils/auth'
export const permission = {
  // mounted是指令的一个生命周期
  mounted(el, binding) {
    // value 获取用户使用自定义指令绑定的内容
    const { value } = binding
    if (!value || value == '') {
      return;
    }
    const user = getUser() || {};
    if (user.isAdmin == 1) {
      return;
    }
    const codes = getButtons();
    if (!codes || codes.length == 0) {
      return;
    }
    for (let i = 0; i < codes.length; i++) {
      if (value == codes[i]) {
        return;
      }
    }
    // 当用户没有这个按钮权限时，设置隐藏这个按钮
    el.style.display = 'none'
  }
}